import React from 'react'

const ThinSeparator = () => {
	return <hr className="thin-separator" />
}

export default ThinSeparator
